import lang from '../lang';

/* Cấu trúc menu: nhóm theo miền nghiệp vụ, xếp theo tần suất dùng (hằng ngày trên
 * cùng, cấu hình/hệ thống dưới cùng). Mục { type: 'section' } là tiêu đề phân vùng,
 * không click được. Nhóm có 'aliases' = activeClass các nhóm CŨ đã gộp vào nhóm này
 * — để ~400 trang cũ truyền parentClass theo tên nhóm cũ vẫn expand/highlight đúng.
 * Sidebar tự suy nhóm active từ URL; parentClass của trang chỉ còn là fallback. */
const MenuItems = {
    AdminSchool: [
        {
            title: "Xem nhanh",
            activeClass: "quick-access-home",
            icon: "fas fa-bolt font-18 icon-side-bar",
            url: '/ad-sas-school',
            permission: "*", // hiện với mọi tài khoản đăng nhập, không gate theo quyền
            isShow: true,
            children: []
        },
        // Dashboard — ẩn tạm thời (giữ nguyên object để bật lại sau, không xóa)
        // {
        //     title: lang.menu?.dashboard || "Dashboard",
        //     activeClass: "dashboard",
        //     icon: "fas fa-tachometer-alt font-18 icon-side-bar",
        //     url: '/ad-sas-school/dashboard-ban-giam-hieu',
        //     permission: "DB0", // DASHBOARD_VIEW (trước gate nhầm U0 = USER_VIEW)
        //     isShow: true,
        //     children: []
        // },
        {
            title: lang.menu?.groupMyWork || "Công việc của tôi",
            activeClass: "my-work",
            icon: "fas fa-tasks font-18 icon-side-bar",
            permission: "TSK0|DD0|U0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.taskWorkspace || "Công việc",
                    activeClass: "task-workspace",
                    parentClass: "my-work",
                    icon: "caret",
                    url: '/ad-sas-school/cong-viec',
                    permission: "TSK0",
                    isShow: false,
                },
                {
                    title: lang.menu?.teacherAttendance || "Điểm danh lớp chủ nhiệm",
                    activeClass: "teacher-attendance",
                    parentClass: "my-work",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-lop-chu-nhiem',
                    permission: "DD0",
                    isShow: false,
                },
                {
                    title: lang.menu?.personalTimekeeping || "Chấm công cá nhân",
                    activeClass: "timekeeping-teacher",
                    parentClass: "my-work",
                    icon: "caret",
                    url: '/ad-sas-school/cham-cong-ca-nhan',
                    permission: "U0",
                    isShow: false,
                },
                {
                    title: lang.menu?.studentLeaveRequest || "Xin nghỉ phép hộ h/s",
                    activeClass: "xin-nghi-ho-hs",
                    parentClass: "my-work",
                    icon: "caret",
                    url: '/ad-sas-school/xin-nghi-hoc-sinh',
                    permission: "DD0",
                    isShow: false,
                },
                {
                    title: lang.menu?.staffTimekeepingView || "NV xem chấm công",
                    activeClass: "timekeeping-report-review",
                    parentClass: "my-work",
                    icon: "caret",
                    url: '/ad-sas-school/nhan-vien-kiem-tra-cham-cong',
                    permission: "U0",
                    isShow: false,
                },
                {
                    title: lang.menu?.staffLessonView || "NV xem chấm tiết",
                    activeClass: "my-lesson-consolidation",
                    parentClass: "my-work",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-cham-tiet-cua-toi',
                    permission: "U0",
                    isShow: false,
                },
            ],
        },
        {
            type: 'section',
            title: lang.menu?.sectionEducation || "Học sinh & Giảng dạy",
        },
        {
            title: lang.menu?.attendance || "Điểm danh",
            activeClass: "attendance-management",
            icon: "fas fa-user-check font-18 icon-side-bar",
            permission: "DD0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.dailyAttendance || "Điểm danh hàng ngày",
                    activeClass: "attendance-everyday",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh',
                    permission: "DD0", // Updated: GU0 → DD0 (DIEM_DANH_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.attendanceReport || "Báo cáo điểm danh",
                    activeClass: "attendance-report",
                    parentClass: "attendance-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-diem-danh-hang-ngay',
                    permission: "DD0", // Updated: GU0 → DD0 (DIEM_DANH_VIEW with report)
                    isShow: false,
                },
            ],
        },
        {
            title: lang.menu?.groupStudentParent || "Học sinh & Phụ huynh",
            activeClass: "student-management",
            icon: "fas fa-graduation-cap font-18 icon-side-bar",
            aliases: ["phu-huynh-management"],
            permission: "ST0|STT0|SP0|STR0|P0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.studentProfile || "Hồ sơ học sinh",
                    activeClass: "student-info-management",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thong-tin-hoc-sinh',
                    permission: "ST0", // Keep ST0 (STUDENT_VIEW)
                },
                {
                    title: lang.menu?.firstYearClassAssignment || "Phân lớp học sinh đầu cấp",
                    activeClass: "accept-first-year",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/phan-lop-hoc-sinh-dau-cap',
                    permission: "STT0", // STUDENT_TRANSFER — server enforce hasPermission('STUDENT','TRANSFER')
                },
                {
                    title: lang.menu?.gradeManagement || "Quản lý điểm",
                    activeClass: "subject-point",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-diem-hoc-sinh',
                    permission: "SP0", // Updated: U0 → SP0 (SUBJECT_POINT_VIEW)
                },
                {
                    title: lang.menu?.finalGradeReport || "Báo cáo điểm tổng kết",
                    activeClass: "student-report-management",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-bao-cao-diem-hoc-sinh',
                    permission: "STR0", // Updated: U0 → STR0 (STUDENT_REPORT_VIEW)
                },
                {
                    title: lang.menu?.parentList || "Danh sách phụ huynh",
                    activeClass: "phu-huynh",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-phu-huynh',
                    permission: "P0", // Updated: SG0 → P0 (PARENT_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.parentLink || "Liên kết phụ huynh",
                    activeClass: "map-phu-huynh",
                    parentClass: "student-management",
                    icon: "caret",
                    url: '/ad-sas-school/lien-ket-phu-huynh',
                    permission: "P0", // Updated: SG0 → P0 (PARENT_VIEW)
                    isShow: false,
                },
            ],
        },
        {
            title: lang.menu?.groupTeaching || "Giảng dạy & TKB",
            activeClass: "teaching",
            icon: "fas fa-chalkboard font-18 icon-side-bar",
            aliases: ["timetable-management", "lesson-plan-management"],
            permission: "SS0|TA0|SL0|SSCH2|LPV|LP4", // union quyền các mục con (bài giảng đã tách LPV/LP4 — SCR-003 xong)
            isShow: false,
            children: [
                {
                    title: lang.menu?.schedule || "Thời khóa biểu",
                    activeClass: "schedule-management",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/thoi-khoa-bieu',
                    permission: "SS0", // SUBJECT_SCHEDULE_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.autoTimetable || "Sinh TKB tự động",
                    activeClass: "auto-timetable",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/sinh-tkb',
                    permission: "TA0", // TEACHER_ASSIGNMENT_VIEW - related to timetable
                    isShow: false,
                },
                {
                    title: lang.menu?.timetableConstraints || "Ràng buộc TKB",
                    activeClass: "timetable-constraints",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/rang-buoc-tkb',
                    permission: "TA0", // TEACHER_ASSIGNMENT_VIEW - related to timetable
                    isShow: false,
                },
                {
                    title: lang.menu?.teachingAssignment || "Phân công giảng dạy",
                    activeClass: "teacher-assignment",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-phan-cong-giang-day',
                    permission: "TA0", // Updated: Y0|D0 → TA0 (TEACHER_ASSIGNMENT_VIEW)
                    isShow: false,
                },
                {
                    id: "swap-lesson-list",
                    title: lang.menu?.swapLesson || "Đơn đổi tiết",
                    url: "/ad-sas-school/quan-ly-doi-tiet",
                    activeClass: "swap-lesson-management",
                    parentClass: "teaching",
                    permission: "SL0" // Updated: GU0 → SL0 (SWAP_LESSON_VIEW)
                },
                {
                    title: lang.menu?.timetableSync || "Đồng bộ TKB",
                    activeClass: "timetable-sync",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/dong-bo-tkb',
                    permission: "SSCH2", // SUBJECT_SCHEDULE_EDIT — đồng bộ là thao tác ghi TKB
                    isShow: false,
                },
                {
                    title: lang.menu?.lessonPlanList || "Danh sách bài giảng",
                    activeClass: "lesson-plan-list",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-bai-giang',
                    permission: "LPV", // LESSON_PLAN_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.lessonPlanReview || "Kiểm duyệt bài giảng",
                    activeClass: "lesson-plan-review",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/kiem-duyet-bai-giang',
                    permission: "LP4", // LESSON_PLAN_REVIEW (LP3 là DELETE — mã đúng theo seed là LP4)
                    isShow: false,
                },
                {
                    title: lang.menu?.homeworkManagement || "Quản lý bài tập",
                    activeClass: "homework-management",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-bai-tap',
                    permission: "LPV", // LESSON_PLAN_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.resourceLibrary || "Thư viện tài nguyên",
                    activeClass: "resource-library",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/thu-vien-tai-nguyen',
                    permission: "LPV", // LESSON_PLAN_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.cloudStorage || "Kết nối Cloud Storage",
                    activeClass: "cloud-storage",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/ket-noi-cloud-storage',
                    permission: "LPV", // LESSON_PLAN_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.lessonPlanStatistics || "Thống kê",
                    activeClass: "lesson-plan-statistics",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/thong-ke-bai-giang',
                    permission: "LP4", // LESSON_PLAN_REVIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.batchOperations || "Thao tác hàng loạt",
                    activeClass: "batch-operations",
                    parentClass: "teaching",
                    icon: "caret",
                    url: '/ad-sas-school/thao-tac-hang-loat',
                    permission: "LP4", // LESSON_PLAN_REVIEW
                    isShow: false,
                },
            ],
        },
        {
            title: lang.menu?.admissions || "Tuyển sinh",
            activeClass: "admissions-management",
            icon: "fas fa-user-plus font-18 icon-side-bar",
            permission: "QCG0|QCA0|QC0|QCA6|QCP0|QCT0|QCC0|DAZ0|DAR0|DAS0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.customerList || "Danh sách khách hàng",
                    activeClass: "list-customer-admissions",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/danh-sach-khach-hang',
                    permission: "QC0",
                    isShow: false,
                },
                {
                    title: lang.menu?.enrollmentCampaign || "Chiến dịch tuyển sinh",
                    activeClass: "enrollment-campaign",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/chien-dich-tuyen-sinh',
                    permission: "QCA0",
                    isShow: false,
                },
                {
                    title: lang.menu?.kindergartenPartner || "Đối tác mầm non",
                    activeClass: "admissions-partner",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/doi-tac-mam-non',
                    permission: "QCP0",
                    isShow: false,
                },
                {
                    title: lang.menu?.testSession || "Đợt test đầu vào",
                    activeClass: "admissions-test-session",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/dot-test',
                    permission: "QCT0",
                    isShow: false,
                },
                {
                    title: lang.menu?.admissionBudget || "Ngân sách tuyển sinh",
                    activeClass: "admissions-budget",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/ngan-sach',
                    permission: "QCC0",
                    isShow: false,
                },
                {
                    title: lang.menu?.admissionsReport || "Báo cáo",
                    activeClass: "payment-report-admissions",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/bao-cao',
                    permission: "QCA6",
                    isShow: true,
                },
                {
                    title: lang.menu?.statusNameManagement || "Quản lý tên trạng thái",
                    activeClass: "admissions-name-status",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/quan-ly-ten-trang-thai',
                    permission: "QCG0",
                    isShow: false,
                },
                {
                    title: lang.menu?.customerGroupManagement || "Quản lý nhóm khách hàng",
                    activeClass: "admissions-group-permission",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/tuyen-sinh/quan-ly-nhom-khach-hang',
                    permission: "QCG0",
                    isShow: false,
                },
                {
                    title: lang.menu?.admissionsZoneDiscount || "Cấu hình ưu đãi tuyển sinh khu vực",
                    activeClass: "admissions-zone",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-uu-dai-tuyen-sinh-khu-vuc',
                    permission: "DAZ0", // Updated: AA0|SG0 → DAZ0 (DISCOUNT_ADMISSIONS_ZONE_VIEW)
                },
                {
                    title: lang.menu?.admissionsRegisterDiscount || "Cấu hình ưu đãi tuyển sinh ngày đăng ký",
                    activeClass: "admissions-register",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-uu-dai-tuyen-sinh-ngay-dang-ky',
                    permission: "DAR0", // Updated: AR0 → DAR0 (DISCOUNT_ADMISSIONS_REGISTER_VIEW)
                },
                {
                    title: lang.menu?.specialDiscount || "Cấu hình ưu đãi đặc biệt",
                    activeClass: "admissions-special",
                    parentClass: "admissions-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-uu-dai-dac-biet',
                    permission: "DAS0", // Updated: AS0 → DAS0 (DISCOUNT_ADMISSIONS_SPECIAL_VIEW)
                },
            ],
        },
        {
            type: 'section',
            title: lang.menu?.sectionCommunication || "Truyền thông",
        },
        {
            title: lang.menu?.groupNotificationNews || "Thông báo & Tin tức",
            activeClass: "communication",
            icon: "fas fa-bullhorn font-18 icon-side-bar",
            aliases: ["sms-management"],
            permission: "NF0|N0|SREM0|SMS0|SMSS0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.notification || "Thông báo",
                    activeClass: "noti-management",
                    parentClass: "communication",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thong-bao',
                    permission: "NF0",
                    isShow: false,
                },
                {
                    title: lang.menu?.news || "Tin tức",
                    activeClass: "news-management",
                    parentClass: "communication",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-tin-tuc',
                    permission: "N0",
                    isShow: false,
                },
                {
                    title: lang.menu?.dailyReminderManagement || "Dặn dò hàng ngày",
                    activeClass: "daily-reminder-management",
                    parentClass: "communication",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dan-do-hang-ngay',
                    permission: "SREM0",
                    isShow: false,
                },
                {
                    title: lang.menu?.sendExternalSms || "Quản lý gửi tin nhắn ngoài",
                    activeClass: "sms-send-outside",
                    parentClass: "communication",
                    icon: "caret",
                    url: '/ad-sas-school/gui-tin-nhan-ngoai-he-thong',
                    permission: "SMS0", // Updated: SM0 → SMS0 (SMS_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.sendAdvertisingEmail || "Quản lý gửi Email quảng cáo",
                    activeClass: "gmail-send",
                    parentClass: "communication",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-email-quang-cao',
                    permission: "SMSS0", // Updated: EM0 → SMSS0 (SMS_SEND_VIEW)
                    isShow: false,
                },
            ],
        },
        {
            title: lang.menu?.chatManagement || "Tin nhắn",
            activeClass: "chat-management",
            icon: "fas fa-comments font-18 icon-side-bar",
            url: '/ad-sas-school/chat',
            permission: "CG0", // CHAT_GROUP_VIEW (trước mượn tạm SS0 nên ai xem TKB cũng thấy Tin nhắn)
            isShow: false,
            children: []
        },
        {
            title: lang.menu?.email || "Email",
            activeClass: "email-management",
            icon: "fas fa-envelope font-18 icon-side-bar",
            permission: "SMS0|CNE0|FEM0", // nhom Email = union con: SMS0(SMS) | CNE0(class notify) | FEM0(fee email)
            isShow: false,
            children: [
                {
                    title: lang.menu?.emailInbox || "Hộp thư đến",
                    activeClass: "email-inbox",
                    parentClass: "email-management",
                    icon: "caret",
                    url: '/ad-sas-school/email-inbox',
                    permission: "SMS0",
                    isShow: false,
                },
                {
                    title: lang.menu?.emailCompose || "Soạn email",
                    activeClass: "email-compose",
                    parentClass: "email-management",
                    icon: "caret",
                    url: '/ad-sas-school/soan-email',
                    permission: "SMS0",
                    isShow: false,
                },
                {
                    title: lang.menu?.emailOutbox || "Đã gửi",
                    activeClass: "email-outbox",
                    parentClass: "email-management",
                    icon: "caret",
                    url: '/ad-sas-school/email-da-gui',
                    permission: "SMS0",
                    isShow: false,
                },
                {
                    title: lang.menu?.emailAccount || "Tài khoản email",
                    activeClass: "email-account",
                    parentClass: "email-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-tai-khoan-email',
                    permission: "SMS0",
                    isShow: false,
                },
                {
                    title: lang.menu?.emailTemplate || "Template email",
                    activeClass: "email-template",
                    parentClass: "email-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-template-email',
                    permission: "SMS0",
                    isShow: false,
                },
                {
                    title: lang.menu?.emailLabel || "Nhãn email",
                    activeClass: "email-label",
                    parentClass: "email-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-nhan-email',
                    permission: "SMS0",
                    isShow: false,
                },
                {
                    title: lang.menu?.emailAutoRecipient || "Người nhận tự động",
                    activeClass: "email-auto-recipient",
                    parentClass: "email-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-nguoi-nhan-tu-dong',
                    permission: "SMS0",
                    isShow: false,
                },
                {
                    title: lang.menu?.classNotifyEmail || "Gửi thông báo lớp",
                    activeClass: "class-notify-email",
                    parentClass: "email-management",
                    icon: "caret",
                    url: '/ad-sas-school/gui-thong-bao-lop',
                    permission: "CNE0", // CLASS_NOTIFY_EMAIL_VIEW (CNE1 = gửi, check ở nút)
                    isShow: false,
                },
                {
                    title: lang.menu?.feeEmail || "Gửi email học phí",
                    activeClass: "fee-email",
                    parentClass: "email-management",
                    icon: "caret",
                    url: '/ad-sas-school/gui-email-hoc-phi',
                    permission: "FEM0", // FEE_EMAIL VIEW - server: FeeEmailController @hasAuthority('FEM0')
                    isShow: false,
                },
                {
                    title: lang.menu?.serviceFeeEmail || "Gửi email khoản thu dịch vụ",
                    activeClass: "service-fee-email",
                    parentClass: "email-management",
                    icon: "caret",
                    url: '/ad-sas-school/gui-email-dich-vu',
                    permission: "FEM0", // FEE_EMAIL VIEW - server: FeeEmailController @hasAuthority('FEM0')
                    isShow: false,
                },
            ],
        },
        {
            type: 'section',
            title: lang.menu?.sectionServices || "Dịch vụ",
        },
        {
            title: lang.menu?.groupMeal || "Suất ăn",
            activeClass: "meal-service",
            icon: "fas fa-utensils font-18 icon-side-bar",
            aliases: ["eat-management"],
            permission: "ET0|ER0|EC0|ERP0|FAD0|MPT0", // FAD0: kế toán/bếp chỉ có quyền cửa Face ID vẫn vào được màn đối soát
            isShow: false,
            children: [
                {
                    title: lang.menu?.mealService || "Quản lý dịch vụ ăn",
                    activeClass: "eat-list",
                    parentClass: "meal-service",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-dich-vu-an',
                    permission: "ET0", // Updated: GU0 → ET0 (EAT_TYPE_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.mealRegister || "Đăng ký ăn",
                    activeClass: "eat-register",
                    parentClass: "meal-service",
                    icon: "caret",
                    url: '/ad-sas-school/dang-ky-an-hoc-sinh',
                    permission: "ER0", // Updated: GU0 → ER0 (EAT_REGISTER_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.mealAttendance || "Điểm danh ăn",
                    activeClass: "attendance-eat",
                    parentClass: "meal-service",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-an',
                    permission: "EC0", // Updated: GU0 → EC0 (EAT_CHECK_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.mealReport || "Báo cáo ăn",
                    activeClass: "eat-report",
                    parentClass: "meal-service",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-an',
                    permission: "ERP0", // Updated: GU0 → EGR0 (EAT_REPORT_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.lunchReport || "Báo cáo suất ăn trưa",
                    activeClass: "lunch-report",
                    parentClass: "meal-service",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-suat-an-trua',
                    permission: "EC0", // EAT_CHECK_VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.mealPortion || "Chia định lượng chín",
                    activeClass: "meal-portion",
                    parentClass: "meal-service",
                    icon: "caret",
                    url: '/ad-sas-school/chia-dinh-luong-chin',
                    permission: "MPT0", // MEAL_PORTION:VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.mealPortionConfig || "Cấu hình định lượng chín",
                    activeClass: "meal-portion-config",
                    parentClass: "meal-service",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-dinh-luong-chin',
                    permission: "MPT2", // MEAL_PORTION:CONFIG — chỉ admin trường, bếp không sửa hệ số
                    isShow: false,
                },
                {
                    title: lang.menu?.mealFaceCheck || "Đối soát chấm ăn (Face ID)",
                    activeClass: "face-meal-check",
                    parentClass: "meal-service",
                    icon: "caret",
                    url: '/ad-sas-school/doi-soat-cham-an-khuon-mat',
                    permission: "FAD0", // FACE_DOOR:VIEW — nhật ký chấm ăn bằng khuôn mặt
                    isShow: false,
                },
            ],
        },
        {
            title: lang.menu?.nutrition || "Dinh dưỡng",
            activeClass: "menu-management",
            icon: "fas fa-apple-alt font-18 icon-side-bar",
            permission: "FOODT0|FOODG0|FOODS0|FOOD0|FOODE0|M0|FMPV", // FMPV: ảnh bữa ăn theo khối (trang Thực đơn hàng ngày)
            isShow: false,
            children: [
                {
                    title: lang.menu?.menuManagement || "Thực đơn",
                    activeClass: "menu",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thuc-don',
                    permission: "M0", // KEEP: M0 (not in mapping, but used in menu)
                },
                {
                    title: lang.menu?.weeklyMenu || "Thực đơn tuần",
                    activeClass: "menu-week",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/thuc-don-tuan',
                    permission: "M0", // KEEP: MW0 (not in mapping, but used in menu)
                },
                {
                    title: lang.menu?.dailyMenu || "Thực đơn hàng ngày",
                    activeClass: "menu-daily",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/thuc-don-hang-ngay',
                    permission: "M0|FMPV", // M0 thực đơn; FMPV xem ảnh bữa ăn theo khối (FOOD_MENU_PHOTO)
                },
                {
                    title: lang.menu?.dish || "Món ăn",
                    activeClass: "food-eat",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-mon-an',
                    permission: "FOODE0", // Updated: FOE0 → FOODE0 (FOOD_EAT_VIEW)
                },
                {
                    title: lang.menu?.food || "Thực phẩm",
                    activeClass: "food",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thuc-pham',
                    permission: "FOOD0", // Updated: FO0 → FOOD0 (FOOD_VIEW)
                },
                {
                    title: lang.menu?.foodGroup || "Nhóm thực phẩm",
                    activeClass: "food-group",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/nhom-thuc-pham',
                    permission: "FOODG0", // Updated: FG0 → FOODG0 (FOOD_GROUP_VIEW)
                },
                {
                    title: lang.menu?.foodType || "Loại thực phẩm",
                    activeClass: "food-type",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/loai-thuc-pham',
                    permission: "FOODT0", // Updated: FT0 → FOODT0 (FOOD_TYPE_VIEW)
                },
                {
                    title: lang.menu?.supplier || "Nhà cung cấp",
                    activeClass: "supplier",
                    parentClass: "menu-management",
                    icon: "caret",
                    url: '/ad-sas-school/nha-cung-cap',
                    permission: "FOODS0", // Updated: FS0 → FOODS0 (FOOD_SUPPLIER_VIEW)
                },
            ],
        },
        {
            title: lang.menu?.bus || "Xe bus",
            activeClass: "bus-management",
            icon: "fas fa-bus font-18 icon-side-bar",
            permission: "BT0|BR0|BRG0|BC0",
            children: [
                {
                    title: lang.menu?.busServiceType || "Loại dịch vụ xe bus",
                    activeClass: "price-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-loai-tuyen-xe-bus',
                    permission: "BT0", // Updated: BT0 → BRT0 (BUS_TYPE_VIEW)
                },
                {
                    title: lang.menu?.busRoute || "Tuyến xe bus",
                    activeClass: "list-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-tuyen-xe-bus',
                    permission: "BR0", // Updated: BU0 → BR0 (BUS_ROUTE_VIEW)
                },
                {
                    title: lang.menu?.busRegisterRequest || "Yêu cầu đăng ký xe bus",
                    activeClass: "bus-registration-request",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/yeu-cau-dang-ky-xe-bus',
                    permission: "BRG0", // Updated: BR0 → BRG0 (BUS_REGISTRATION_REQUEST_VIEW)
                },
                {
                    title: lang.menu?.busRegister || "Đăng ký xe bus",
                    activeClass: "register-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-dang-ky-xe-bus',
                    permission: "BRG0", // Updated: BR0 → BRG0 (BUS_REGISTER_VIEW)
                },
                {
                    title: lang.menu?.busTracking || "Theo dõi xe bus",
                    activeClass: "bus-tracking",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/theo-doi-xe-bus',
                    permission: "BR0", // BUS_ROUTE_VIEW - same permission as viewing bus routes
                },
                // {
                //     title: lang.menu?.busPayment || "Thanh toán xe bus",
                //     activeClass: "pay-bus",
                //     parentClass: "bus-management",
                //     icon: "caret",
                //     url: '/ad-sas-school/danh-sach-thanh-toan',
                //     permission: "BRG0", // BUS_REGISTER_VIEW - thanh toán đi theo quyền đăng ký xe bus
                // },
                {
                    title: lang.menu?.busAttendanceReport || "Báo cáo điểm danh xe bus",
                    activeClass: "report-bus",
                    parentClass: "bus-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-xe-bus',
                    permission: "BC0", // Updated: BRRT → BRC0 (BUS_CHECK_VIEW)
                },
            ],
        },
        {
            title: lang.menu?.latePickup || "Đón muộn",
            activeClass: "late-pick-up-management",
            icon: "fas fa-clock font-18 icon-side-bar",
            permission: "LPC0|LPR0|LPRP0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.latePickupConfig || "Cấu hình giá đón muộn",
                    activeClass: "config-late",
                    parentClass: "late-pick-up-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-gia-don-muon',
                    permission: "LPC0", // Updated: LPUC0 → LPC0 (LATE_PICK_UP_CONFIG_VIEW)
                },
                {
                    title: lang.menu?.latePickupRegister || "Đăng ký đón muộn",
                    activeClass: "register-late",
                    parentClass: "late-pick-up-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-dang-ky-don-muon',
                    permission: "LPR0", // Updated: LPUR0 → LPR0 (LATE_PICK_UP_REGISTER_VIEW)
                },
                {
                    title: lang.menu?.latePickupAttendance || "Điểm danh đón muộn",
                    activeClass: "attendance-late-pick-up",
                    parentClass: "late-pick-up-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-don-muon',
                    permission: "LPR0", // Updated: GU0 → LPR0 (LATE_PICK_UP_RECEIVE_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.latePickupReport || "Báo cáo đón muộn",
                    activeClass: "report-pick-late-up",
                    parentClass: "late-pick-up-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-don-muon',
                    permission: "LPRP0", // Updated: LPURT0 → LPRP0 (LATE_PICK_UP_REPORT_VIEW)
                },
            ],
        },
        {
            title: lang.menu?.groupClb || "Câu lạc bộ",
            activeClass: "clb-management",
            icon: "fas fa-futbol font-18 icon-side-bar",
            permission: "CLB0|CLBR0|CLBC0|CLBRP0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.clbClass || "Quản lý lớp CLB",
                    activeClass: "class-clb",
                    parentClass: "clb-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-lop-clb',
                    permission: "CLB0", // Updated: CL0 → CLB0 (CLB_VIEW)
                },
                {
                    title: lang.menu?.clbRegister || "Quản lý đăng ký CLB",
                    activeClass: "register-clb",
                    parentClass: "clb-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dang-ky-clb',
                    permission: "CLBR0", // Updated: CR0 → CLBR0 (CLB_REGISTER_VIEW)
                },
                {
                    title: lang.menu?.clbAttendance || "Điểm danh CLB",
                    activeClass: "attendance-clb",
                    parentClass: "clb-management",
                    icon: "caret",
                    url: '/ad-sas-school/diem-danh-clb',
                    permission: "CLBC0", // Updated: GU0 → CLBC0 (CLB_CHECK_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.clbAttendanceReport || "Báo cáo điểm danh CLB",
                    activeClass: "attendance-report-clb",
                    parentClass: "clb-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-diem-danh-clb',
                    permission: "CLBRP0", // Updated: GU0 → CLBRP0 (CLB_REPORT_CHECK_VIEW)
                    isShow: false,
                },
            ],
        },
        {
            title: lang.menu?.groupOtherServices || "Dịch vụ khác",
            activeClass: "service-management",
            icon: "fas fa-concierge-bell font-18 icon-side-bar",
            aliases: ["club-services"], // tên nhóm gộp cũ "CLB & Dịch vụ khác" (đã tách 2026-08)
            permission: "SI0|SO0|SR0|SRQ0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.serviceApproval || "Duyệt yêu cầu đăng ký/hủy dịch vụ",
                    activeClass: "service-approval",
                    parentClass: "service-management",
                    icon: "caret",
                    url: '/ad-sas-school/duyet-yeu-cau-dich-vu',
                    permission: "SRQ0", // SERVICE_REQUEST_VIEW
                },
                {
                    title: lang.menu?.serviceRegister || "Quản lý đăng ký dịch vụ",
                    activeClass: "register-service",
                    parentClass: "service-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dang-ky-dich-vu',
                    permission: "SR0", // Updated: SR0 → SOR0 (SERVICE_OTHER_REGISTER_VIEW)
                },
                {
                    title: lang.menu?.serviceManagement || "Quản lý dịch vụ",
                    activeClass: "list-service",
                    parentClass: "service-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dich-vu-khac',
                    permission: "SO0", // Updated: SE0 → SO0 (SERVICE_OTHER_VIEW)
                },
                {
                    title: lang.menu?.productManagement || "Quản lý sản phẩm",
                    activeClass: "list-service-product",
                    parentClass: "service-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-san-pham-dich-vu',
                    permission: "SI0", // Updated: SP0 → SI0 (SERVICE_ITEM_VIEW)
                },
            ],
        },
        {
            title: lang.menu?.medical || "Y tế",
            activeClass: "medical-management",
            icon: "fas fa-clinic-medical font-18 icon-side-bar",
            permission: "MED0",
            isShow: false,
            children: [
                {
                    title: lang.menu?.medicalRoom || "Khám phòng y tế",
                    activeClass: "medical-room",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/kham-phong-y-te',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.healthRecord || "Hồ sơ sức khỏe",
                    activeClass: "health-record",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/ho-so-suc-khoe',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.periodicExam || "Khám định kỳ",
                    activeClass: "periodic-exam",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/kham-dinh-ky',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.examCampaign || "Đợt khám",
                    activeClass: "exam-campaign",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/dot-kham',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.vaccination || "Tiêm chủng",
                    activeClass: "vaccination",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/tiem-chung',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.healthInsurance || "Bảo hiểm y tế",
                    activeClass: "health-insurance",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-hiem-y-te',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.medicineManagement || "Quản lý thuốc",
                    activeClass: "medicine-management",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thuoc',
                    permission: "MED0",
                    isShow: false,
                },
                {
                    title: lang.menu?.medicationManagement || "Dặn thuốc (cũ)",
                    activeClass: "list-medical-management",
                    parentClass: "medical-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-dan-thuoc',
                    permission: "MED0",
                    isShow: false,
                },
            ],
        },
        {
            type: 'section',
            title: lang.menu?.sectionFinance || "Tài chính",
        },
        {
            title: lang.menu?.groupTuition || "Học phí & Thu chi",
            activeClass: "wallet-management",
            icon: "fas fa-wallet font-18 icon-side-bar",
            permission: "FFY0|FER4|FFYR0|INV0|FE4|FE2", // nhom Hoc phi & Thu chi = union quyen cua cac muc con
            isShow: false,
            children: [
                {
                    title: lang.menu?.feeItemCollection || "Quản lý thu các khoản phí",
                    activeClass: "fee-item-manager",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thu-khoan-phi',
                    permission: "FFY0", // Updated: FFYM0 → FFY0 (FEE_FIRST_YEAR_VIEW)
                },
                {
                    title: lang.menu?.tuitionReport || "Báo cáo thu học phí",
                    activeClass: "list-fee",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-hoc-phi-hoc-sinh',
                    permission: "FER4", // FEE_REPORT VIEW - server: FeeReportController
                },
                {
                    title: lang.menu?.feeCollectionReport || "Báo cáo thu các khoản phí",
                    activeClass: "fee-first-year-report",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-thu-phi',
                    permission: "FFYR0", // Updated: FFER0 → FFYR0 (FEE_FIRST_YEAR_REPORT_VIEW)
                },
                {
                    title: lang.menu?.receiptManagement || "Quản lý thu chi",
                    activeClass: "phieu-thu",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-phieu-thu',
                    permission: "INV0", // INVOICE VIEW - server: InvoiceController
                },
                {
                    title: "Đối chiếu học phí",
                    activeClass: "fee-audit",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/doi-chieu-hoc-phi',
                    permission: "FE4", // FEE VIEW - server: FeeAuditController
                },
                {
                    title: lang.menu?.vcbQrManagement || "Quản lý QR thanh toán",
                    activeClass: "vcb-qr",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-qr-thanh-toan',
                    permission: "INV0", // INVOICE VIEW - server: InvoiceController
                },
                {
                    title: lang.menu?.feeFormula || "Công thức tính phí",
                    activeClass: "fee-item",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-cac-khoan-phi',
                    permission: "FE4", // FEE VIEW - server: FeeController
                },
                {
                    title: lang.menu?.feeDryRun || "Tính thử học phí",
                    activeClass: "fee-dry-run",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/tinh-thu-hoc-phi',
                    permission: "FE4", // FEE VIEW - server: FeeCalculationController /dry-run
                },
                {
                    title: "Nạp tham số phí",
                    activeClass: "fee-param-import",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/nap-tham-so-phi',
                    permission: "FE2", // FEE EDIT - server: FeeParamImportController
                },
                {
                    title: lang.menu?.tuitionConfig || "Cấu hình giá học phí",
                    activeClass: "fee",
                    parentClass: "wallet-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-gia-hoc-phi',
                    permission: "FE4", // FEE VIEW - server: FeeController
                },
            ],
        },
        {
            title: lang.menu?.payment || "Thanh toán",
            activeClass: "payment-management",
            icon: "fas fa-credit-card font-18 icon-side-bar",
            permission: "PD0|BIDV0|BIDVA|BIDV7|RF1|POS0",
            isShow: false,
            children: [
                {
                    title: "Tổng quan thanh toán",
                    activeClass: "payment-dashboard",
                    parentClass: "payment-management",
                    icon: "caret",
                    url: '/ad-sas-school/tong-quan-thanh-toan',
                    permission: "PD0",
                },
                {
                    title: "Giao dịch BIDV",
                    activeClass: "bidv-transaction",
                    parentClass: "payment-management",
                    icon: "caret",
                    url: '/ad-sas-school/giao-dich-bidv',
                    permission: "BIDV7",
                },
                {
                    title: "Quản lý hoàn tiền",
                    activeClass: "refund",
                    parentClass: "payment-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-hoan-tien',
                    permission: "RF1",
                },
                {
                    title: "Đối chiếu sao kê trường",
                    activeClass: "school-bank-recon",
                    parentClass: "payment-management",
                    icon: "caret",
                    url: '/ad-sas-school/doi-chieu-sao-ke-truong',
                    permission: "BIDVA",
                },
                {
                    // Theo dõi BIDV có tự đẩy biến động số dư / sao kê T-1 vào endpoint H2H không.
                    // Dùng lại quyền BIDVA (đã có trong chuỗi permission của nhóm cha ở trên).
                    title: "Theo dõi BIDV H2H",
                    activeClass: "bidv-h2h-monitor",
                    parentClass: "payment-management",
                    icon: "caret",
                    url: '/ad-sas-school/theo-doi-bidv-h2h',
                    permission: "BIDVA",
                },
                {
                    title: "Cấu hình BIDV",
                    activeClass: "bidv-config",
                    parentClass: "payment-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-bidv',
                    permission: "BIDV0",
                },
                {
                    title: "Cấu hình máy POS",
                    activeClass: "pos-config",
                    parentClass: "payment-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-pos',
                    permission: "POS0",
                },
                {
                    title: "TK nhận học phí (QR tĩnh)",
                    activeClass: "school-bank-account",
                    parentClass: "payment-management",
                    icon: "caret",
                    url: '/ad-sas-school/tai-khoan-nhan-hoc-phi',
                    permission: "BIDV0",
                },
            ],
        },
        {
            type: 'section',
            title: lang.menu?.sectionOperations || "Vận hành",
        },
        {
            title: lang.menu?.groupStaff || "Nhân sự",
            activeClass: "staff-management",
            icon: "fas fa-users font-18 icon-side-bar",
            aliases: ["hr-timekeeping"], // nhóm "Nhân sự & Chấm công" cũ đã tách làm 2 (2026-09-09)
            permission: "OF0|AL0", // union quyền các mục con
            isShow: false,
            children: [
                {
                    title: lang.menu?.staffList || "Quản lý cán bộ",
                    activeClass: "list-staff",
                    parentClass: "staff-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-can-bo',
                    permission: "OF0", // OFFICER_VIEW (mã O0 không tồn tại; T0 khiến giáo viên thấy menu quản lý cán bộ)
                },
                {
                    title: lang.menu?.leaveApplication || "Đơn xin nghỉ",
                    activeClass: "application-leave-management",
                    parentClass: "staff-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-don-xin-nghi',
                    permission: "AL0", // Updated: GU0 → AL0 (APPLICATION_LEAVE_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.officerReport || "Báo cáo nhân sự",
                    activeClass: "officer-report",
                    parentClass: "staff-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-nhan-su',
                    permission: "OF0", // SCR-026 — mọi endpoint báo cáo (kể cả tải Excel) đều là OFFICER_VIEW
                },
                {
                    title: lang.menu?.officerDocumentType || "Danh mục hồ sơ cán bộ",
                    activeClass: "officer-document-type",
                    parentClass: "staff-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-muc-ho-so-can-bo',
                    permission: "OF0", // SCR-026 — xem danh mục dùng OFFICER_VIEW; thêm/sửa gác riêng bằng OF2 trong trang
                },
                {
                    title: lang.menu?.officerContractDoc || "Sổ văn bản nhân sự",
                    activeClass: "officer-contract-doc",
                    parentClass: "staff-management",
                    icon: "caret",
                    url: '/ad-sas-school/so-van-ban-nhan-su',
                    permission: "OF0", // SCR-035 — dùng lại nhóm quyền OFFICER, nhóm này chỉ có OF0/OF2/OF3
                },
            ],
        },
        {
            title: lang.menu?.groupTimekeeping || "Chấm công",
            activeClass: "timekeeping-management",
            icon: "fas fa-user-clock font-18 icon-side-bar",
            aliases: ["hr-timekeeping"], // nhóm "Nhân sự & Chấm công" cũ đã tách làm 2 (2026-09-09)
            permission: "TK0|SPT0|STK0|TKRT|TLC0|LC0|FAI0|FAC0|FAE0|FAD0", // union quyền các mục con
            isShow: false,
            children: [
                {
                    title: lang.menu?.timekeepingList || "Chấm công",
                    activeClass: "timekeeping-list",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-cham-cong',
                    permission: "TK0", // Updated: GU0 → TK0 (TIMEKEEPING_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.timekeepingReport || "Báo cáo chấm công",
                    activeClass: "timekeeping-report",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-cham-cong',
                    permission: "TKRT", // TIMEKEEPING_REPORT — mã trong DB là TKRT, "TKR" không tồn tại nên mục này từng ẩn với mọi tài khoản
                    isShow: false,
                },
                {
                    title: lang.menu?.lessonReport || "Báo cáo chấm tiết",
                    activeClass: "timekeeping-teacher-lesson-report",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-cham-tiet',
                    permission: "TLC0", // Updated: U0 → TLC0 (TEACHER_LESSON_CONSOLIDATION_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.complaintApproval || "Duyệt khiếu nại",
                    activeClass: "application-leave-approval",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-don-khieu-nai-cham-cong',
                    permission: "SPT0|STK0", // SUPPLEMENTARY_TIMEKEEPING_LIST — seed local dùng SPT0, DB thật còn có cả STK0; "ST0" là STUDENT_VIEW nên KHÔNG được dùng
                    isShow: false,
                },
                {
                    title: lang.menu?.lessonComplaint || "Quản lý khiếu nại chấm tiết",
                    activeClass: "lesson-complaint-management",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/khieu-nai-cham-tiet',
                    permission: "LC0", // Updated: U0 → LC0 (LESSON_COMPLAINT_VIEW)
                    isShow: true,
                },
                {
                    title: lang.menu?.officerLeaveBalance || "Quản lý phép nhân viên",
                    activeClass: "officer-leave-balance-management",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-phep-nhan-vien',
                    permission: "TK0", // TIMEKEEPING:VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.officerLeaveMonth || "Theo dõi phép theo tháng",
                    activeClass: "officer-leave-month",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/theo-doi-phep-theo-thang',
                    permission: "TK0", // TIMEKEEPING:VIEW — SCR-018
                    isShow: true,
                },
                {
                    title: lang.menu?.faceImage || "Ảnh khuôn mặt (Face ID)",
                    activeClass: "face-image-management",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-anh-khuon-mat',
                    permission: "FAI0", // FACE_IMAGE:VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.faceClient || "Thiết bị Face ID",
                    activeClass: "face-client-management",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-thiet-bi-face-id',
                    permission: "FAC0", // FACE_CLIENT:VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.faceEvent || "Sự kiện nhận diện (Face ID)",
                    activeClass: "face-event-lookup",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/tra-cuu-su-kien-khuon-mat',
                    permission: "FAE0", // FACE_EVENT:VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.faceDoor || "Cửa nhận diện (Face ID)",
                    activeClass: "face-door-management",
                    parentClass: "timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-cua-khuon-mat',
                    permission: "FAD0", // FACE_DOOR:VIEW
                    isShow: false,
                },
            ],
        },
        {
            title: lang.menu?.timekeepingConfig || "Cấu hình chấm công",
            activeClass: "config-timekeeping-management",
            icon: "fas fa-cogs font-18 icon-side-bar",
            permission: "TK0|SH0|TA0|SW0|EV0|ATTL0|TKI", // nhom Cau hinh cham cong = union quyen cua cac muc con
            isShow: false,
            children: [
                {
                    title: lang.menu?.config || "Cấu hình",
                    activeClass: "config-management",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-cham-cong',
                    permission: "TK0", // TIMEKEEPING VIEW - server: LeaveGeneralController
                    isShow: false,
                },
                {
                    title: lang.menu?.workShift || "Ca làm việc",
                    activeClass: "shift-management",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-ca-lam-viec',
                    permission: "SH0", // Updated: Y0|D0 → SH0 (SHIFT_VIEW)
                    isShow: false,
                },
                {
                    title: lang.menu?.workCalendar || "Quản lý lịch làm việc",
                    activeClass: "work-calendar",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-lich-lam-viec',
                    permission: "TA0", // Updated: Y0|D0 → TA0 (TEACHER_ASSIGNMENT_VIEW)
                    isShow: false,
                },
                {
                    id: "supplementary-work",
                    title: lang.menu?.supplementaryWork || "Quản lý việc bổ sung",
                    url: "/ad-sas-school/cong-viec-bo-sung",
                    activeClass: "supplementary-work-management",
                    parentClass: "config-timekeeping-management",
                    permission: "SW0" // Updated: Y0|D0 → SW0 (SUPPLEMENTARY_WORK_VIEW)
                },
                {
                    id: "event",
                    title: lang.menu?.eventAssignment || "Phân công sự kiện",
                    url: "/ad-sas-school/quan-ly-su-kien",
                    activeClass: "event-management",
                    parentClass: "config-timekeeping-management",
                    permission: "EV0", // EVENT VIEW
                },
                {
                    title: lang.menu?.attendanceZone || "Quản lý vùng chấm công",
                    activeClass: "attendance-location-management",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-vung-cham-cong',
                    permission: "ATTL0", // ATTENDANCE_LOCATION_VIEW (AL0 là APPLICATION_LEAVE_VIEW — mã đúng theo seed là ATTL0)
                    isShow: false,
                },
                {
                    // Máy chấm công ZKTeco: dò IP trong LAN, tải file MMYYYY.xls, import thẳng.
                    // Trước nằm sâu trong trang Import (3 lớp click) nên gần như không ai tìm ra.
                    title: lang.menu?.timekeepingDevice || "Quản lý máy chấm công",
                    activeClass: "timekeeping-device",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-may-cham-cong',
                    permission: "TKI", // TIMEKEEPING_IMPORT — đúng hành động của màn này (kéo dữ liệu từ máy về)
                    isShow: false,
                },
                {
                    title: lang.menu?.attendanceWifi || "Quản lý wifi chấm công",
                    activeClass: "attendance-wifi",
                    parentClass: "config-timekeeping-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-wifi-cham-cong',
                    permission: "TK0", // Updated: GU0 → TK0 (TIMEKEEPING_VIEW - wifi config related)
                    isShow: false,
                },
            ],
        },
        {
            title: lang.menu?.groupInventoryPurchase || "Kho & Mua sắm",
            activeClass: "inventory-purchase",
            icon: "fas fa-warehouse font-18 icon-side-bar",
            aliases: ["inventory-management", "procurement-management"],
            // 2026-08-30: INV0 thực chất là INVOICE/VIEW (hóa đơn) và PRC0 không bộ quyền nào được cấp
            // ⇒ nhóm này hiện/ẩn sai. Server dùng INVENTORY/VIEW (INV4) + PROCUREMENT/VIEW (PRC4).
            permission: "INV4|PRC4", // SCR-003: chờ seed SUP0|PRD0|STI0|STO0 rồi tách quyền nhập/xuất/danh mục
            isShow: false,
            // 2026-09-16: xếp lại theo NHỊP LÀM VIỆC — việc làm mỗi ngày lên trên, thứ khai báo
            // một lần xuống dưới cùng. Trước đó 14 mục nằm phẳng theo thứ tự lắp ghép: hai mục
            // báo cáo lạc ở đầu và cuối, còn "Tồn kho" (số dư) đứng cạnh "Kho hàng" (danh sách
            // kho) nên rất dễ bấm nhầm.
            // `activeClass` và `url` GIỮ NGUYÊN: đổi là hỏng link cũ và mất highlight menu.
            children: [
                { type: 'section', title: "Chứng từ hàng ngày" },
                {
                    title: lang.menu?.stockIn || "Phiếu nhập kho",
                    activeClass: "stock-in-management",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/phieu-nhap-kho',
                    permission: "INV4", // INVENTORY VIEW - server: controller inventory/*
                    isShow: false,
                },
                {
                    title: lang.menu?.stockOut || "Phiếu xuất kho",
                    activeClass: "stock-out-management",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/phieu-xuat-kho',
                    permission: "INV4", // INVENTORY VIEW - server: controller inventory/*
                    isShow: false,
                },

                { type: 'section', title: "Mua sắm" },
                // Xếp đúng trình tự chứng từ: đề nghị → đặt hàng → nhận hàng.
                {
                    title: lang.menu?.purchaseRequest || "Yêu cầu mua hàng",
                    activeClass: "purchase-request",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/yeu-cau-mua-hang',
                    permission: "PRC4", // PROCUREMENT VIEW - server: controller procurement/*
                    isShow: false,
                },
                {
                    title: lang.menu?.purchaseOrder || "Đơn đặt hàng",
                    activeClass: "purchase-order",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/don-dat-hang',
                    permission: "PRC4", // PROCUREMENT VIEW - server: controller procurement/*
                    isShow: false,
                },
                {
                    title: lang.menu?.goodsReceipt || "Phiếu nhận hàng",
                    activeClass: "goods-receipt",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/phieu-nhan-hang',
                    permission: "PRC4", // PROCUREMENT VIEW - server: controller procurement/*
                    isShow: false,
                },

                { type: 'section', title: "Gói hàng đầu năm" },
                // Đúng thứ tự phải làm: khai khuôn gói → đăng ký cho từng lớp → xem đơn của
                // từng em → báo cáo. Ai mở menu lần đầu đọc từ trên xuống là ra quy trình.
                {
                    // SCR-036: KHUÔN gói hàng đầu năm (áo + quần + vở...). Chỉ là khuôn —
                    // đăng ký cho học sinh nằm ở mục dưới.
                    title: lang.menu?.goodsCombo || "Gói hàng đầu năm",
                    activeClass: "goods-combo-management",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/goi-hang',
                    permission: "INV0",
                    isShow: false,
                },
                {
                    // SCR-036: lưới nhập size/số lượng cả lớp một lần, thay cho việc
                    // lập tay 30 đơn đồng phục.
                    title: lang.menu?.classGoodsRegister || "Đăng ký gói theo lớp",
                    activeClass: "class-goods-register",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/dang-ky-goi-theo-lop',
                    permission: "INV0",
                    isShow: false,
                },
                {
                    // Tên cũ "Đơn đồng phục HS" hẹp hơn thứ màn hình này quản: gói đầu năm gồm
                    // cả SGK, vở, bút. Server gọi đúng là student-goods-order = đơn HÀNG HOÁ.
                    title: lang.menu?.studentGoodsOrder || "Đơn hàng hoá học sinh",
                    activeClass: "student-goods-order",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/don-dong-phuc',
                    permission: "INV0",
                    isShow: false,
                },
                {
                    title: lang.menu?.studentGoodsOrderReport || "Báo cáo đơn hàng hoá HS",
                    activeClass: "student-goods-order-report",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    // Xem báo cáo là quyền INVRT ở server; menu vẫn gác bằng INV0 như các mục kho khác.
                    url: '/ad-sas-school/bao-cao-don-dong-phuc',
                    permission: "INV0",
                    isShow: false,
                },

                { type: 'section', title: "Tra cứu & báo cáo" },
                {
                    // "Tồn kho hiện tại" chứ không phải "Tồn kho": tên cũ đứng cạnh "Kho hàng"
                    // (danh sách kho) thì hai mục đọc gần như nhau, người dùng bấm nhầm liên tục.
                    title: lang.menu?.inventory || "Tồn kho hiện tại",
                    activeClass: "inventory-list-management",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/ton-kho',
                    permission: "INV4", // INVENTORY VIEW - server: controller inventory/*
                    isShow: false,
                },
                {
                    // SCR-023: sổ kho = nhật ký biến động; lọc đủ kho + quy cách thành Thẻ kho S12-DN
                    title: lang.menu?.stockLedger || "Sổ kho / Thẻ kho",
                    activeClass: "stock-ledger-management",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/so-kho',
                    permission: "INV4",
                    isShow: false,
                },
                {
                    // SCR-023 Phase 3: báo cáo N-X-T mẫu S11-DN. Quyền INVRT (INVENTORY.REPORT),
                    // KHÔNG dùng INV4 — báo cáo phơi giá vốn/giá trị tồn nên gác riêng.
                    title: lang.menu?.nxtReport || "Báo cáo Nhập - Xuất - Tồn",
                    activeClass: "nxt-report-management",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/bao-cao-nxt',
                    permission: "INVRT",
                    isShow: false,
                },

                { type: 'section', title: "Danh mục" },
                // Khai báo một lần rồi hầu như không đụng tới — để cuối cho khỏi che việc hàng ngày.
                {
                    title: lang.menu?.product || "Sản phẩm",
                    activeClass: "product-management",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/san-pham',
                    permission: "INV4", // INVENTORY VIEW - server: controller inventory/*
                    isShow: false,
                },
                {
                    // "Danh sách kho" — đây là nơi KHAI các kho, không phải nơi xem số tồn.
                    title: lang.menu?.warehouse || "Danh sách kho",
                    activeClass: "warehouse-management",
                    parentClass: "inventory-purchase",
                    icon: "caret",
                    url: '/ad-sas-school/kho-hang',
                    permission: "INV4", // INVENTORY VIEW - server: controller inventory/*
                    isShow: false,
                },
            ],
        },
        {
            title: lang.menu?.assets || "Tài sản",
            activeClass: "asset-management",
            icon: "fas fa-cubes font-18 icon-side-bar",
            permission: "AST0", // SCR-003: chờ seed ASTC0|ASTL0|ASTM0|ASTCK0|ASTDP0 để tách quyền
            isShow: false,
            children: [
                {
                    title: lang.menu?.assetCategory || "Danh mục tài sản",
                    activeClass: "asset-category",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/danh-muc-tai-san',
                    permission: "AST0", // SCR-003: tạm dùng AST0 (đã seed), chờ mã chi tiết
                    isShow: false,
                },
                {
                    title: lang.menu?.assetLocation || "Vị trí tài sản",
                    activeClass: "asset-location",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/vi-tri-tai-san',
                    permission: "AST0", // SCR-003: tạm dùng AST0 (đã seed), chờ mã chi tiết
                    isShow: false,
                },
                {
                    title: lang.menu?.assetList || "Danh sách tài sản",
                    activeClass: "asset-list",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-tai-san',
                    permission: "AST0", // SCR-003: tạm dùng AST0 (đã seed), chờ mã chi tiết
                    isShow: false,
                },
                {
                    title: lang.menu?.assetMaintenance || "Bảo trì tài sản",
                    activeClass: "asset-maintenance",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/bao-tri-tai-san',
                    permission: "AST0", // SCR-003: tạm dùng AST0 (đã seed), chờ mã chi tiết
                    isShow: false,
                },
                {
                    title: lang.menu?.assetCheckout || "Mượn/Trả tài sản",
                    activeClass: "asset-checkout",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/muon-tra-tai-san',
                    permission: "AST0", // SCR-003: tạm dùng AST0 (đã seed), chờ mã chi tiết
                    isShow: false,
                },
                {
                    title: lang.menu?.assetDepreciation || "Khấu hao tài sản",
                    activeClass: "asset-depreciation",
                    parentClass: "asset-management",
                    icon: "caret",
                    url: '/ad-sas-school/khau-hao-tai-san',
                    permission: "AST0", // SCR-003: tạm dùng AST0 (đã seed), chờ mã chi tiết
                    isShow: false,
                },
            ],
        },
        {
            type: 'section',
            title: lang.menu?.sectionSystem || "Hệ thống",
        },
        {
            title: lang.menu?.groupUserPermission || "Người dùng & Phân quyền",
            activeClass: "user-permission",
            icon: "fas fa-user-shield font-18 icon-side-bar",
            permission: "U0|GU0|PM0|UG0", // nhom Nguoi dung & Phan quyen = union quyen cua cac muc con
            isShow: false,
            children: [
                {
                    title: lang.menu?.userManagement || "Quản lý người dùng",
                    activeClass: "user-management",
                    parentClass: "user-permission",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-nguoi-dung',
                    permission: "U0",
                    isShow: false,
                },
                {
                    title: lang.menu?.permissionGroupManagement || "Quản lý nhóm quyền",
                    activeClass: "permission-group-management",
                    parentClass: "user-permission",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-nhom-quyen',
                    permission: "GU0", // GROUP_USER VIEW - server: PermissionGroupController
                    isShow: false,
                },
                {
                    title: lang.menu?.permissionManagement || "Quản lý quyền",
                    activeClass: "permission-management",
                    parentClass: "user-permission",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-quyen',
                    permission: "PM0", // PERMISSION VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.userGroupPermission || "Phân quyền nhóm người dùng",
                    activeClass: "group-permission-management",
                    parentClass: "user-permission",
                    icon: "caret",
                    url: '/ad-sas-school/phan-quyen-nhom-nguoi-dung',
                    permission: "UG0", // Updated: GU0 → UG0 (USER_GROUP_MANAGEMENT_VIEW)
                    isShow: false,
                },
            ],
        },
        {
            title: lang.menu?.groupSchoolData || "Trường & Dữ liệu",
            activeClass: "school-data",
            icon: "fas fa-school font-18 icon-side-bar",
            aliases: ["system-school-management"],
            permission: "SGV|S2|D0|CL0|CT0|STT0|HM0|ZZHM01|AVR0|ZZ0016|LOG0", // nhom Truong & Du lieu = union quyen cua cac muc con
            isShow: false,
            children: [
                {
                    title: lang.menu?.schoolGroupManagement || "Quản lý nhóm trường",
                    activeClass: "list-group-school-management",
                    parentClass: "school-data",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-nhom-truong',
                    permission: "SGV", // SCHOOL_GROUP VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.schoolManagement || "Quản lý trường học",
                    activeClass: "list-school-management",
                    parentClass: "school-data",
                    icon: "caret",
                    url: '/ad-sas-school/danh-sach-truong-hoc',
                    permission: "S2", // SCHOOL EDIT - man hinh quan tri truong hoc (S0 qua rong: moi role deu co do dung chung /school/my-school)
                    isShow: false,
                },
                {
                    title: lang.menu?.dataDeclaration || "Khai báo dữ liệu",
                    activeClass: "declaration-management",
                    parentClass: "school-data",
                    icon: "caret",
                    url: '/ad-sas-school/khai-bao-du-lieu',
                    permission: "D0|CL0", // DEPARTMENT VIEW | CLASSROOM VIEW
                    isShow: false,
                },
                {
                    title: lang.menu?.dataTransfer || "Kết chuyển dữ liệu",
                    activeClass: "transfer-management",
                    parentClass: "school-data",
                    icon: "caret",
                    url: '/ad-sas-school/ket-chuyen-du-lieu',
                    permission: "CT0|STT0", // CLASS_TRANSFER | STUDENT_TRANSFER — server enforce đúng 2 quyền này
                    isShow: false,
                },
                {
                    title: lang.menu?.homeMenuConfig || "Cấu hình trang chủ App",
                    activeClass: "home-menu-config",
                    parentClass: "school-data",
                    icon: "caret",
                    url: '/ad-sas-school/cau-hinh-trang-chu-app',
                    permission: "HM0|ZZHM01", // HOME_MENU VIEW — OR mã fallback vì checkPermission so khớp substring
                    isShow: false,
                },
                {
                    title: lang.menu?.versionManagement || "Quản lý phiên bản",
                    activeClass: "app-version",
                    parentClass: "school-data",
                    icon: "caret",
                    url: '/ad-sas-school/quan-ly-phien-ban',
                    // SCR-016: APP_VERSION VIEW (AVR0) - CHI role ADMIN_SYSTEM duoc cap ma nay.
                    // OR them ma fallback ZZ0016 (seed_all_permissions_complete.sql dung ma nay khi
                    // AVR0 da bi ma cu chiem) vi checkPermission so khop substring.
                    // Truoc day gate bang "U0" (USER VIEW) - gan nhu moi role deu co => menu hien cho tat ca.
                    permission: "AVR0|ZZ0016",
                    isShow: false,
                },
                {
                    title: lang.menu?.otaManagement || "Cập nhật OTA",
                    activeClass: "ota-management",
                    parentClass: "school-data",
                    icon: "caret",
                    url: '/ad-sas-school/cap-nhat-ota',
                    // OTA0 = OTA VIEW. Phat hanh ban OTA anh huong toan bo may dang dung app
                    // => chi role quan tri he thong duoc cap nhom ma OTA0..OTA4.
                    permission: "OTA0",
                    isShow: false,
                },
                {
                    title: lang.menu?.logManagement || "Quản lý LOG",
                    activeClass: "log-management",
                    parentClass: "school-data",
                    icon: "caret",
                    url: '/ad-sas-school/log-management',
                    permission: "LOG0", // LOG VIEW - server: SasLogController
                    isShow: false,
                },
            ],
        },
    ]
};

export default MenuItems;
